<div class="content">
  <div class="description subtitle">{{ 'AUTOMATIONS.EDITOR.TASKS.REOPEN_OPPORTUNITY.DESCRIPTION' | translate }}</div>

  <glxy-form-field required="true">
    <glxy-label>Reason</glxy-label>
    <input type="text" matInput [formControl]="reasonFormControl" />
  </glxy-form-field>
</div>
